import { Event, NavigationEnd, NavigationStart, RoutesRecognized } from '@angular/router';

export function isNavigationStart(route: Event): route is NavigationStart {
  return route instanceof NavigationStart;
}

export function isNavigationEnd(route: Event): route is NavigationEnd {
  return route instanceof NavigationEnd;
}

export function isRoutesRecognized(route: Event): route is RoutesRecognized {
  return route instanceof RoutesRecognized;
}
